import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4221712"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "header" }
const _hoisted_2 = { class: "alm-navbar navbar navbar-expand navbar-static-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow me-auto" }, [
  /*#__PURE__*/_createTextVNode("QuickSource"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_4 = { class: "navbar-nav noselect" }
const _hoisted_5 = { class: "nav-item mls-guide-reference" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Import MLS")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "nav-item add-comp-guide-reference" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Add Comp")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-link" }
const _hoisted_15 = { class: "custom-control custom-checkbox data-discrepancies-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-control-label",
  for: "dataDiscrepancies"
}, " Only show data discrepancies", -1))
const _hoisted_17 = { class: "nav-item dropdown" }
const _hoisted_18 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-cog" }, null, -1))
const _hoisted_20 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Configure Settings")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-life-ring" }, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" View User Tutorial")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "text-end pe-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "#",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.launchMLSImportModal && _ctx.launchMLSImportModal(...args)))
            }, _hoisted_8)
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "#",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.launchAddManualCompModal && _ctx.launchAddManualCompModal(...args)))
            }, _hoisted_12)
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "dataDiscrepancies",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onlyShowDiscrepancyRows($event.target.checked)))
                }, null, 32),
                _hoisted_16
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("a", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_ctx.userName), 1)
            ]),
            _createElementVNode("ul", _hoisted_20, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.launchConfigureSettingsModal && _ctx.launchConfigureSettingsModal(...args)))
                }, _hoisted_23)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.launchUserTutorial && _ctx.launchUserTutorial(...args)))
                }, _hoisted_26)
              ]),
              _createElementVNode("li", _hoisted_27, "v" + _toDisplayString(_ctx.uadVersion), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.modalConfigureSettings.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalConfigureSettings.component), {
          key: 0,
          defaultTabIdx: _ctx.modalConfigureSettings.defaultTabIdx,
          onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalConfigureSettings.show = false))
        }, null, 8, ["defaultTabIdx"]))
      : _createCommentVNode("", true),
    (_ctx.modalAddManualComp.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalAddManualComp.component), {
          key: 1,
          onHide: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalAddManualComp.show = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}